import * as olStyle from 'ol/style';
import { getVuetifyThemeVar } from '@/utils/mapLayerTheme';

const getThemeVar = getVuetifyThemeVar;

export function pillar(feature, colors, b, v) {
  let color = colors[colors.length - 1];

  const total =
    feature.getProperties() != undefined ? feature.getProperties()['total'] : undefined;
  const index =
    feature.getProperties() != undefined ? feature.getProperties()['index'] : undefined;
  const height = feature.getGeometry().getCoordinates()[2];

  for (let i = 0; i < 9; i++) {
    if (height >= b + v * (i + 1) && height < b + v * (i + 2)) {
      color = colors[i];
    }
  }

  if (total != undefined && index != undefined) {
    return new olStyle.Style({
      image: new olStyle.Circle({
        radius: 4,
        fill: new olStyle.Fill({
          color: color
        })
      }),
      text: new olStyle.Text({
        font: '11px sans-serif',
        text: '[' + index + '/' + total + ']' + height.toFixed(2) + 'm',
        stroke: new olStyle.Stroke({
          color: getThemeVar('--v-text-base', 'black'),
          width: 2
        }),
        fill: new olStyle.Fill({
          color: getThemeVar('--v-surface-base', '#FFFFFF')
        })
      })
    });
  }
  return new olStyle.Style({
    image: new olStyle.Circle({
      radius: 4,
      fill: new olStyle.Fill({
        color: color
      })
    })
  });
}

export function selected_line(color) {
  return new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: color,
      width: 2
    })
  });
}

export function dashed_line(color) {
  return [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: color,
        lineDash: [12],
        width: 10
      })
    })
  ];
}

export function color_point(color) {
  return [
    new olStyle.Style({
      image: new olStyle.Circle({
        radius: 2,
        fill: new olStyle.Fill({
          color: color
        })
      })
    })
  ];
}
